import * as React from 'react'
import { useState, useEffect, useMemo, useRef } from 'react'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { useSelector } from 'react-redux'
import {Box, Divider, IconButton, Typography, FormControl, InputLabel, Select, MenuItem, TableContainer, ButtonGroup, Paper,
  Checkbox,
  FormControlLabel,
} from '@mui/material'
import { printVariable, getPngSize, getTargetWidth, columnToIndex, fixXlsxPopupPrintTitles, replaceXlsxPopupHeaderText } from '@util/helper'
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined'
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined'
import { useMediaQuery, useTheme } from '@mui/material'
import WebService from '@util/webService'
import useSnackbar from '@hooks/useSnackbar'
import useIndicator from '@hooks/useIndicator'
import axios from 'axios'
import { Fragment } from 'react'
import useAlert from '@hooks/useAlert'
import moment from 'moment'
import Tab from '@mui/material/Tab'
import TabList from '@mui/lab/TabList'
import TabContext from '@mui/lab/TabContext'
import TabPanel from '@mui/lab/TabPanel'

import MUITable from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableFooter from '@mui/material/TableFooter'
import MyTableHead from '@components/MyTableHead'
import * as ExcelJS from 'exceljs'
import ControlPoint from '@mui/icons-material/ControlPoint'
import XlsxPopulate from 'xlsx-populate/browser/xlsx-populate'

const dayMap = {
  'S001': '월',
  'S002': '화',
  'S003': '수',
  'S004': '목',
  'S005': '금',
  'S006': '토',
  'S007': '일',
}
const statCodeMap = {
  S000: ' ',
  S001: '○',
  S200: 'X1',
  S201: 'X2',
  S202: 'X3',
  S203: 'X4',
  S204: 'X5',
  S205: 'X6',
  S206: 'X7',
  S003: '△',
  S004: '◐',
  H001: 'D',
  H002: 'H',
  X001: '-',
  X002: 'ⓧ',
}

const offCodeMap = {
  F000: '미정',
  F001: '보호자 동행',
  F002: '대리인 동행',
  F003: '학원차 이용',
  F004: '자율귀가',
  F005: '돌봄 이동',
  F006: '스쿨버스 하교',
  F007: '학교셔틀 하교',
  F008: '방과후 이동',
  F009: '안전도우미 인솔',
}

const greyBg = {
  type: 'pattern',
  pattern: 'solid',
  fgColor: { argb: 'f5f5f5' },
  bgColor: { argb: 'f5f5f5' },
}


const ALL = '전체'
const iFormat= 'YYYY-MM-DD HH:mm:ss'
const oFormat= 'MM-DD'
const defSmst = {id:-1, year:'', gisu: ''}

const ManagerAttdncPartMany = ({dialogHandler, smst, choice }) =>  {
  const [openSnackbar] = useSnackbar()
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  const schola = useSelector(state => state.scholaReducer)
  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'))
  const {alert, renderAlert} = useAlert()
  const contentRef = useRef(null)
  const [dnOption, set_dnOption] = useState({
    portrait: false,
    sign: false,
  })

  const getHeadRow = (lectureId) => {
    const row =[' No. ', ' 학년 ', ' 반 ', ' 번호 ', '  이름  ', '보호자전화번호 ', ' 귀가방법 ', '비고']
    let attdncs = smst.lectures.find(l => l.id === lectureId)?.attdncs

    if(choice.period === 1) {
      attdncs = attdncs.filter(r => {
        const yyyymm = moment(r.lectureTime, iFormat).format('YYYY-MM')
        return yyyymm === choice.month
      })
    }
    else if(choice.period === 2) {
      /*
      attdncs = attdncs.filter(r => {
        const yyyymmdd = moment(r.lectureTime, iFormat).format('YYYY-MM-DD')
        return yyyymmdd === choice.targetDate
      })
      */
      attdncs = attdncs.filter(r => {
        const dt = moment(r.lectureTime, iFormat)
        const from = moment(choice.targetDate, 'YYYY-MM-DD')
        const to = moment(choice.targetDate2, 'YYYY-MM-DD')
        return dt.isBetween(from, to, 'day', '[]' )
      })

    }

    attdncs.forEach((a, idx) => {
      let mmdd = moment(a.lectureTime, iFormat).format(oFormat)
      if(a.subLectureTime) {
        mmdd = '(취)'+mmdd + ' (보)' + moment(a.subLectureTime,iFormat).format(oFormat) + ' ' + a.subStartTime + '~' + a.subEndTime
      }
      row.push(mmdd)
    })

    if(attdncs.length > 0) {
      return row
    }
    else {
      return null
    }
  }

  const getDataRows = (lectureId) => {
    const lecture = smst.lectures.find(l => l.id === lectureId)
    let students = lecture?.students
    if(choice.grade !== ALL)  {
      students = students.filter(s => +s.grade === +choice.grade)
    }
    if(choice.className !== ALL) {
      students = students.filter(s => s.className === choice.className)
    }

    let attdncs = lecture?.attdncs
    if(choice.period === 1) {
      attdncs = attdncs.filter(r => {
        const yyyymm = moment(r.lectureTime, iFormat).format('YYYY-MM')
        return yyyymm === choice.month
      })
    }
    else if(choice.period === 2) {
      /*
      attdncs = attdncs.filter(r => {
        const dt = moment(r.lectureTime, iFormat).format('YYYY-MM-DD')
        const yyyymmdd = moment(r.lectureTime, iFormat).format('YYYY-MM-DD')
        return yyyymmdd === choice.targetDate
      })
      */

      attdncs = attdncs.filter(r => {
        const dt = moment(r.lectureTime, iFormat)
        const from = moment(choice.targetDate, 'YYYY-MM-DD')
        const to = moment(choice.targetDate2, 'YYYY-MM-DD')
        return dt.isBetween(from, to, 'day', '[]' )
      })
    }

    const bings = lecture?.bings
    const rows = []
    students.forEach((student, idx) => {
      const phone = choice.hidePhone ? 'XXXXXXXXXXX' : student.gdnPhone
      const row = [idx+1, student.grade, student.className, student.classNum, student.name, phone, offCodeMap[student.regi?.offCode], '']
      attdncs.forEach((attdnc, idx2) => {
        const bing = bings.find(r => r.studentId == student.id && r.attdncId === attdnc.id)
        if(bing) {
          row.push(statCodeMap[bing.statCode])
        }
        else {
          // 취소해서 출석부에 없는 것으로 간주
          row.push(statCodeMap['X001'])
        }
      })
      rows.push(row)
    })

    //빈 공간 채워주기
    if(choice.fillEmpty) {
      const diff = lecture?.rcrNum ? lecture?.rcrNum - rows.length : 0
      if(diff > 0) {
        let nextRowNum = rows.length  + 1
        while(nextRowNum <= lecture?.rcrNum) {
          const row = [nextRowNum, '', '', '', '', '', '', '']
          attdncs.forEach((attdnc, idx2) => {
            row.push('')
          })

          rows.push(row)
          nextRowNum  = nextRowNum + 1
        }
      }
    }
    return rows
  }

  const tabs = React.useMemo(() => {
    const tabArray = []
    let tidx = 1
    smst.lectures.forEach((lecture, idx) => {
      const headRow = getHeadRow(lecture.id)
      const dataRows = getDataRows(lecture.id)
      if(headRow && dataRows.length > 0) {
        const tab = {
          label: `${tidx}.${lecture.title}`,
          value: lecture.id,
        }
        tidx = tidx + 1
        tabArray.push(tab)
      }
    })
    return tabArray
  },[smst])

  const [tabValue, set_tabValue] = tabs.length > 0 ? useState(tabs[0].value) : useState('')

  const getHeaderText = (lectureId) => {
    const left = `${schola.name} ${smst.year}년 ${smst.gisu}기`
    const center = '방과후 학교 출석부'
    const lecture = smst.lectures.find(l => l.id === lectureId)
    const right = `${lecture.title} ${lecture.teacher.name} ${lecture.schedule}`

    return {
      left: left,
      center: center,
      right: right,
    }
  }




  const handleClose = (event, reason)=> {
    if(reason && reason === 'backdropClick') {
      return
    }
    else {
      dialogHandler[1](false)
    }
  }

  const handleTabChange = (event, newValue) => {
    set_tabValue(newValue)
    contentRef.current.scrollTop = 0
  }

  const downloadTmpl = async (sign) => {
    const url = `/attdnc/download/tmpl/${sign}`
    const response = await axios.get(url, { responseType: 'arraybuffer' })
    const buffer = response.data
    return buffer
  }

  const downloadSignForm = async() => {
    const url = `/attdnc/download/sign/form`
    const resp = await WebService.get(url)
    if(resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    const repMessage = JSON.parse(resp.repMessage)
    return repMessage.dataUrl
  }

  const onDownloadXlxsPopup = async (sign) => {
    const buffer = await downloadTmpl(sign)

    const lectures = []
    let dataRowsMap = {}

    smst.lectures.forEach(lecture => {
      const headRow = getHeadRow(lecture.id)
      const dataRows = getDataRows(lecture.id)
      if(headRow && dataRows.length > 0) {
        dataRowsMap[''+lecture.id] = dataRows
        lectures.push(lecture)
      }
    })

    // 템플릿의 머리글 이미지 스키마를 100% 유지한 채 브라우저 메모리로 로드
    const workbook = await XlsxPopulate.fromDataAsync(buffer)
    const firstSheet = workbook.sheet(0)
    const regex = /[*?:\\\/[\]]/g
    const printOptions = []
    const headerOptions = []

    lectures.forEach((lecture, idx) => {
      const sheetName = `${idx + 1}.${lecture.title}`.replace(regex, '_')
      // const sheet = firstSheet.copyTo(workbook, sheetName);
      const sheet = workbook.cloneSheet(firstSheet, sheetName)
      printOptions.push({
        sheet: sheetName,
        rows: '1:1',
        cols: 'A:G'
      })

      const headerText = getHeaderText(lecture.id)
      headerOptions.push({
        sheet: sheetName,
        replacements: {
          '@LEFT': headerText.left,
          '@CENTER': headerText.center,
          '@RIGHT': headerText.right,
        }
      })
      const headRow = getHeadRow(lecture.id)
      const dataRows = dataRowsMap['' + lecture.id] || []

      // 1. 표 헤더 행 주입 (1행부터 시작)
      headRow.forEach((value, colIdx) => {
        const cell = sheet.row(1).cell(colIdx + 1)
        cell.value(value)
        // 스타일 지정 (xlsx-populate 규격)
        cell.style({
          // fontName: '맑은 고딕',
          bold: true,
          horizontalAlignment: 'center',
          // fill: greyBg.replace('#', ''), // 헥사코드 앞 '#' 제거 필요
          border: true
        })
      })

      // 2. 학생 데이터 로우 추가 (2행부터 순수하게 쭉 누적)
      dataRows.forEach((row, rowIdx) => {
        const currentRowNum = rowIdx + 2
        row.forEach((value, colIdx) => {
          const cell = sheet.row(currentRowNum).cell(colIdx + 1)
          cell.value(value)
          cell.style({
            // fontName: '맑은 고딕',
            fontSize: 10,
            horizontalAlignment: 'center',
            border: true
          })
        })
        // 첫 번째 열 greyBg 채우기 로직 있을 경우
        // sheet.row(currentRowNum).cell(1).style({ fill: greyBg.replace('#', '') })
      })

      // 3. 열 너비 세팅
      // xlsx-populate는 1부터 시작하는 순수 루프나 가변 너비 지정이 가능합니다.
      sheet._columns.forEach((column, colIdx) => {
        const colNumber = colIdx + 1
        if (colNumber <= 4) {
          sheet.column(colNumber).width(5)
        } else if (colNumber === 5) {
          sheet.column(colNumber).width(9) // 이름
        } else if (colNumber === 6) {
          sheet.column(colNumber).width(15) // 전화번호
        } else if (colNumber === 7) {
          sheet.column(colNumber).width(9) // 귀가방법
        } else {
          // 나머지 가변 열 처리 기본 너비
          sheet.column(colNumber).width(7)
        }
      })

      // 가로 5장 찢어짐 대응용 엑셀 내장 반복 행 지정 (필요시 활성화)
      // sheet.rowAsync(1).then(row => {
      //   sheet.printOptions().printTitlesRows(1, 1)
      // })
    })

    // 템플릿의 원래 파일 구조를 그대로 유지한 채 브라우저 다운로드 빌드
    const outputBuffer = await workbook.outputAsync()
    const fixedBlob = await fixXlsxPopupPrintTitles(outputBuffer, printOptions)
    // const blob = new Blob([outputBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
    const blob = await replaceXlsxPopupHeaderText(fixedBlob, headerOptions)
    const link = document.createElement('a')
    link.href = window.URL.createObjectURL(blob)

    let filename = `${schola.name}_${smst.year}년${smst.gisu}기_`
    if(choice.period === 0) filename += `${ALL}기간`
    if(choice.period === 1) filename += `${choice.month}월`
    if(choice.period === 2) filename += `${choice.targetDate}~${choice.targetDate2}일`
    filename += `_${choice.grade}학년_${choice.className}반.xlsx`

    link.download = filename
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  const onDownload = async() => {
    const sign = dnOption.sign ? 1 : 0
    const buffer = await downloadTmpl(sign)
    const workbook = new ExcelJS.Workbook()
    await workbook.xlsx.load(new Uint8Array(buffer))

    const lectures = []
    let dataRowsMap = {}

    smst.lectures.forEach(lecture => {
      const headRow = getHeadRow(lecture.id)
      const dataRows = getDataRows(lecture.id)
      if(headRow && dataRows.length > 0) {
        dataRowsMap[''+lecture.id] = dataRows
        lectures.push(lecture)
      }
    })

    const firstSheet = workbook.getWorksheet(1)
    const regex = /[*?:\\\/[\]]/g

    lectures.forEach((lecture, idx) => {
      // const sheet = workbook.addWorksheet(lecture.title)
      const sheetName = `${idx+1}.${lecture.title}`.replace(regex, '_')
      const sheet = workbook.addWorksheet(sheetName)
      // const sheet = workbook.cloneSheet(idx, sheetName)
      // Copy header and footer
      sheet.headerFooter = Object.assign({}, firstSheet.headerFooter)

      // Copy other sheet properties (adjust as needed)
      sheet.properties.defaultRowHeight = firstSheet.properties.defaultRowHeight

      // Copy page layout information
      sheet.pageSetup = Object.assign({}, firstSheet.pageSetup)
      sheet.pageLayout = true
      sheet.pageSetup.orientation = dnOption.portrait ? 'portrait' : 'landscape'
      sheet.views = [
        {
          state: 'normal',
          zoomScale: 80,
          zoomScaleNormal: 80,
          style: 'pageLayout',
          showGridLines: false,
        },
      ]

      // if (firstSheet._headerFooter) {
      //   sheet._headerFooter = JSON.parse(JSON.stringify(firstSheet._headerFooter))
      // }
      // remove rows
      for (let i = sheet.rowCount; i > 0; i--) {
        sheet.spliceRows(i, 1)
      }

      // set header
      const headerText = getHeaderText(lecture.id)

      const header = sheet.headerFooter.oddHeader
      let mtext= header
      mtext = mtext.replace('@LEFT', headerText.left )
      mtext = mtext.replace('@CENTER', headerText.center)
      mtext = mtext.replace('@RIGHT', headerText.right)
      //
      // sheet.headerFooter.firstHeader= mtext
      // sheet.headerFooter.oddHeader= mtext
      sheet.headerFooter.oddHeader= mtext
      sheet.headerFooter.evenHeader= mtext

      // const footer = sheet.headerFooter.oddFooter
      sheet.headerFooter.evenFooter = sheet.headerFooter.oddFooter

      if(+sign == 1) {
        sheet.addRow([headerText.left])
        sheet.addRow([headerText.right])
        sheet.addRow([])
        sheet.pageSetup.printTitlesRow = '1:3'
      }

      const headRow = getHeadRow(lecture.id)

      // head row
      const excelRow = sheet.addRow(headRow)
      excelRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
        cell.font = {
          name:'맑은 고딕',
          bold: true,
        }
        cell.alignment={horizontal:'center'}
      })
      excelRow.getCell(1).fill = greyBg

      // data row
      const dataRows = dataRowsMap[''+lecture.id]
      dataRows.forEach(row => {
        const excelRow = sheet.addRow(row)
        excelRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
          cell.font = {
            name:'맑은 고딕',
            size:10,
          }
          cell.alignment={horizontal:'center'}
        })
        excelRow.getCell(1).fill = greyBg
      })

      const startNumber = +sign === 0 ? 1 : 4
      sheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
        if(rowNumber >= startNumber) {
          row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
            cell.border = {
              top: {style:'thin'},
              left: {style:'thin'},
              bottom: {style:'thin'},
              right: {style:'thin'},
            }
          })
        }
      })
      // fix col width
      sheet.columns.forEach((column, colNumber) => {
        if(colNumber == 0 || colNumber === 1 || colNumber === 2 || colNumber === 3) {
          column.width = 5
        }
        else if(colNumber === 4) { // 이름
          column.width = 9
        }
        else if(colNumber === 5) {  // 전화번호
          column.width = 15
        }
        else if(colNumber === 6) {  // 귀가방법
          column.width = 9
        }
        else {
          let subExists = false
          column.eachCell({ includeEmpty: true }, (cell, rowNumber) => {
            const cellValueLength = cell.value ? String(cell.value).length : 0
            if(cellValueLength > 7) {
              subExists = true
            }
          })
          if(subExists) {
            column.width = 35
          }
          else {
            column.width = 7
          }

        }
      })
    })

    // make it download
    workbook.removeWorksheet(1)
    workbook.xlsx.writeBuffer().then(buffer => {
      const blob = new Blob([buffer], { type: 'application/octet-stream' })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      let filename = `${schola.name}_${smst.year}년${smst.gisu}기_`
      if(choice.period === 0) {
        filename = filename + `${ALL}기간`
      }
      if(choice.period === 1)  {
        filename = filename + `${choice.month}월`
      }
      if(choice.period === 2)  {
        filename = filename + `${choice.targetDate}~${choice.targetDate2}일`
      }
      filename = filename + `_${choice.grade}학년_${choice.className}반.xlsx`
      link.download = filename
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    })

  }

  const onLoad = async() => {
  }

  useEffect(() => {
    onLoad()
  }, [])

  return (
    <Fragment>
      <Dialog open={dialogHandler[0]} onClose={handleClose} maxWidth='xl' fullWidth disableScrollLock>
        <DialogTitle>
          <Typography variant='h5' align='center'>
            {schola.name}
          </Typography>
          <Typography variant='body2' >
            출석부 옵션: <br/>{smst.year}/{smst.gisu}기수,
            {choice.period === 0 ?  ALL + '기간' : null}
            {choice.period === 1 ?  choice.month + '월': null}
            {choice.period === 2 ?  choice.targetDate +'~' + choice.targetDate2 + '일': null}
            ,{choice.grade}학년, {choice.className}반
          </Typography>
          <Divider />
        </DialogTitle>
        <DialogContent ref={contentRef}>
          <TabContext value={tabValue}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', position: 'sticky', top: 0, backgroundColor: '#fff', overflowX:'auto' }}>
              <TabList onChange={handleTabChange} aria-label='lab API tabs example' scrollButtons="auto" variant='scrollable'>
                {
                  tabs.map((tab, idx) => (
                    <Tab key={idx} label={tab.label} value={tab.value} />
                  ))
                }
              </TabList>
            </Box>

            {
              tabs.map((tab, idx) => {
                const headerText = getHeaderText(tab.value)
                const headRow = getHeadRow(tab.value)
                const dataRows = getDataRows(tab.value)

                return(
                  <TabPanel key={idx} value={tab.value} >
                    <Typography variant='body2' style={{marginTop:-10, marginBottom:10}}>
                      {headerText.left} <br/>
                      {headerText.right} <br/>
                    </Typography>
                    <TableContainer style={{minHeight:'70vh', maxHeight:'100vh', overflow:'initial' }} >
                      <MUITable  style={{whiteSpace:'nowrap', top:100  }} >
                        <MyTableHead >
                          <TableRow>
                            {
                              headRow.map((col, index) => (
                                <TableCell size='small' key={index} style={{
                                  width: 1,
                                  position:'sticky',
                                  top:50,
                                  backgroundColor:'#fafafa',
                                }}>
                                  <div dangerouslySetInnerHTML={{ __html: col }} />
                                </TableCell>
                              ))
                            }
                          </TableRow>
                        </MyTableHead>
                        <TableBody>
                          {
                            dataRows.map((row, rowIdx) => {
                              return (
                                <TableRow key={rowIdx} style={{backgroundColor: row.bing?.statCode.startsWith('X') ? '#ffebee' : null }}>
                                  {
                                    row.map((col,colIdx) =>(
                                      <TableCell size='small' key={colIdx} style={{fontFamily:'sans-serif'}} >
                                        {col}
                                      </TableCell>
                                    ))
                                  }
                                </TableRow>
                              )
                            })
                          }
                        </TableBody>
                      </MUITable>
                      <Typography variant='body2' style={{marginTop:10}}>
                        ※ 출석부 :출석○,결석X,지각△,조퇴◐,취소━,휴강D,임시공휴일H  <br />
                        ※ 결석,조퇴 사유 : 1 질병, 2 현장학습, 3 체험학습, 4 경조사, 5 가족행사, 6 미출석, 7 기타 <br />
                        {/* ※ 귀가방법(F) : 0 미정, 1 보호자 동행, 2 대리인 동행, 3 학원차 이용, 4 자율귀가 */}
                      </Typography>
                    </TableContainer>
                  </TabPanel>
                )
              })
            }
          </TabContext>
        </DialogContent>
        <DialogActions>
          <div style={{display:'flex', flex:1, flexDirection:'row', justifyContent:'center', alignItems:'center'}}>
            <Button onClick={handleClose} style={{margin:5}}>닫기</Button>
            <Box style={{border:'1px solid #ccc', paddingLeft:5, marginLeft:5, borderRadius:5,}}>
            <FormControlLabel
              control={
                <Checkbox
                  color="primary"
                  onChange={(e) => {
                    set_dnOption({...dnOption, portrait: e.target.checked})
                  }}
                  checked={dnOption.portrait === true}
                />
              }
              label={'세로 방향'}
            />
            <FormControlLabel
              control={
                <Checkbox
                  color="primary"
                  onChange={(e) => {
                    set_dnOption({...dnOption, sign: e.target.checked})
                  }}
                  checked={dnOption.sign === true}
                />
              }
              label={'결재란 있음'}
            />
            <Button onClick={() => onDownload()} variant='contained' style={{margin:5}}>출석부 다운로드</Button>
            </Box>

            {/* <Button onClick={() => onDownload(1)} variant='contained' style={{margin:5}}>출석부 다운로드(결재란 있음)</Button> */}
          </div>
        </DialogActions>
      </Dialog>
      {renderIndicator()}
      {renderAlert()}
    </Fragment>

  )
}

export default ManagerAttdncPartMany
